export default __webpack_public_path__ + "static/media/paypal.8a37f7ff.svg";